import { openBlock as r, createElementBlock as t, createElementVNode as n, normalizeStyle as l, createTextVNode as o, createCommentVNode as a } from "vue";
/* empty css                    */
import d from "./design-system.es128.js";
const c = {
  name: "DsProgressBar",
  props: {
    /**
     * Value of the progress bar current status
     */
    progress: Number,
    /**
     * Progress bar maximum possible value
     */
    max: {
      type: Number,
      default: 100
    },
    /**
     * Boolean used to display an indeterminate/infinite progress
     */
    indeterminate: Boolean,
    /**
     * Boolean used to show the progress bar percentage value
     */
    showProgress: Boolean,
    /**
     * Boolean used to hide the progress bar label\'s value number
     */
    hideLabelValue: Boolean,
    /**
     * String used to display the progress bar value label
     */
    label: String
  },
  computed: {
    progressUnit() {
      return this.max / 100;
    },
    progressPercentage() {
      return `${+(this.progress / this.progressUnit).toFixed(2)}%`;
    }
  }
}, m = { class: "progress-bar" }, u = { class: "bar-container" }, _ = {
  key: 0,
  class: "bar-indeterminate"
}, g = { class: "info" }, b = {
  key: 0,
  class: "label-value"
}, h = ["innerHTML"], f = ["innerHTML"], v = ["innerHTML"];
function p(x, s, e, y, L, i) {
  return r(), t("div", m, [
    n("div", u, [
      e.indeterminate ? (r(), t("div", _)) : (r(), t("div", {
        key: 1,
        class: "bar",
        style: l({ width: i.progressPercentage })
      }, null, 4))
    ]),
    s[2] || (s[2] = o()),
    n("div", g, [
      e.label ? (r(), t("div", b, [
        e.hideLabelValue ? a("", !0) : (r(), t("span", {
          key: 0,
          class: "value",
          innerHTML: e.progress
        }, null, 8, h)),
        s[0] || (s[0] = o()),
        n("span", {
          class: "label",
          innerHTML: e.label
        }, null, 8, f)
      ])) : a("", !0),
      s[1] || (s[1] = o()),
      e.max && e.showProgress && !e.indeterminate ? (r(), t("div", {
        key: 1,
        class: "progress",
        innerHTML: i.progressPercentage
      }, null, 8, v)) : a("", !0)
    ])
  ]);
}
const T = /* @__PURE__ */ d(c, [["render", p], ["__scopeId", "data-v-cd434f10"]]);
export {
  T as default
};
//# sourceMappingURL=design-system.es89.js.map
